import { toast } from "sonner";
import client from "@/lib/api";

const empty = (v) => v === undefined || v === null || v === "" || (Array.isArray(v) && v.length === 0);
export const same = (a, b) => (empty(a) && empty(b)) || JSON.stringify(a) === JSON.stringify(b);

// Send only the fields that changed (plus their original values) so stale copies can't overwrite newer edits.
export function buildActionPatch(original, next) {
  const patch = {};
  const base = {};
  Object.keys(next).forEach((k) => {
    if (same(original?.[k], next[k])) return;
    patch[k] = next[k];
    base[k] = original?.[k] ?? null;
  });
  if (!("title" in patch) && next.title) patch.title = next.title;
  return { ...patch, base };
}

export async function saveAction(original, next, scope) {
  const url = `/actions/${original.id}${scope ? `?scope=${scope}` : ""}`;
  const { data } = await client.put(url, buildActionPatch(original, next));
  if (data?.conflicts?.length) {
    toast.warning(`Someone else just changed ${data.conflicts.join(", ")} on this task, so their version was kept. The task has been refreshed.`);
  }
  return data;
}
